/**
 * These are labels for Loki issues. They correspond to status or metadata
 * TODO: Needs updated because it looks like we have a few flavors floating
 * around.
 *  */
export enum IssueStatus {
  /** Issue needs to be fixed by the partner or dev */
  Open = 'Open',
  /** Issue fix has been accepted by a Zapier staff member */
  Closed = 'Closed',
  /** In-between open/closed. Used to signal that the dev has marked the issue
   * as resolved, and ready to be re-evaluated.
   */
  ClosePending = 'Close Pending',
  /** Loki metadata specific to Bouncer. It signals that the issue will block
   * an integration from publishing. The issue must be resolved by the dev.
   */
  Blocking = 'Blocking',
}

export enum IssueType {
  Bug = 'Bug',
  FeatureRequest = 'Feature Request',
}
